import { useCallback } from 'react';
import { useAuth } from 'react-oidc-context';
import { REDIRECT_PATH } from 'utility/constants/auth';

export const PROMPT_LOGIN = 'login';
export const PROMPT_FORCE = 'requireLogin';

/** Standardize login hook while storing recall path */
export function useLogin() {
	const { signinRedirect } = useAuth();

	const login = useCallback(
		/** @param {Parameters<signinRedirect>[0]} [opts] */
		async (opts) => {
			const { origin, href } = globalThis.location;
			const fullpath = href.slice(origin.length);
			sessionStorage.setItem(REDIRECT_PATH, fullpath);
			await signinRedirect(opts);
		},
		[signinRedirect],
	);

	return login;
}

export default useLogin;
